import { useCart, lineKeyOf } from "../contexts/CartContext";
import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { variantLabelOf } from "../lib/variants";

export default function Cart() {
    const { items, updateQuantity, removeItem, total } = useCart();

    if (items.length === 0) {
        return (
            <div data-testid="cart-empty" className="max-w-md mx-auto md:max-w-2xl px-4 py-16 text-center">
                <div className="text-6xl text-brand mb-4">
                    <i className="fa-solid fa-basket-shopping" />
                </div>
                <h1 className="text-2xl font-black text-text-main">السلة فارغة</h1>
                <p className="text-text-muted mt-2">أضف بعض الأصناف من المنيو لتبدأ طلبك</p>
                <Link to="/menu" className="btn-brand inline-block mt-6" data-testid="empty-go-menu">
                    <i className="fa-solid fa-utensils ms-2" /> تصفح المنيو
                </Link>
            </div>
        );
    }

    return (
        <div data-testid="cart-page" className="max-w-md mx-auto md:max-w-2xl px-4 py-6">
            <h1 className="section-title text-3xl mb-6">سلة الطلبات</h1>
            <div className="space-y-3">
                {items.map((it) => {
                    const key = lineKeyOf(it);
                    return (
                        <div
                            key={key}
                            data-testid={`cart-line-${it.item_id}`}
                            className="surface-card p-3 sm:p-4 flex items-start justify-between gap-3"
                        >
                            <div className="flex-1">
                                <div className="font-extrabold text-text-main">{it.name}</div>
                                {it.variant && (
                                    <div className="text-xs text-text-muted mt-0.5">
                                        {variantLabelOf(it.category, it.variant)}
                                    </div>
                                )}
                                {it.notes && (
                                    <div className="text-xs text-text-muted mt-0.5">
                                        <i className="fa-solid fa-note-sticky ms-1" /> {it.notes}
                                    </div>
                                )}
                                <div className="mt-2 flex items-center gap-1 bg-[var(--bg)] border border-[var(--border-subtle)] rounded-full p-1 w-fit">
                                    <button
                                        onClick={() => updateQuantity(key, it.quantity - 1)}
                                        className="w-7 h-7 rounded-full bg-white flex items-center justify-center"
                                        data-testid={`cart-decrease-${it.item_id}`}
                                    >
                                        <Minus className="w-3.5 h-3.5" />
                                    </button>
                                    <span className="w-6 text-center font-extrabold text-sm" data-testid={`cart-qty-${it.item_id}`}>
                                        {it.quantity}
                                    </span>
                                    <button
                                        onClick={() => updateQuantity(key, it.quantity + 1)}
                                        className="w-7 h-7 rounded-full bg-white flex items-center justify-center"
                                        data-testid={`cart-increase-${it.item_id}`}
                                    >
                                        <Plus className="w-3.5 h-3.5" />
                                    </button>
                                </div>
                            </div>
                            <div className="text-end">
                                <div className="text-brand font-black" data-testid={`cart-line-total-${it.item_id}`}>
                                    {(it.price * it.quantity).toFixed(2)} ر.س
                                </div>
                                <button
                                    onClick={() => removeItem(key)}
                                    className="text-text-muted mt-2 hover:text-red-600 transition"
                                    data-testid={`cart-remove-${it.item_id}`}
                                    aria-label="حذف"
                                >
                                    <Trash2 className="w-4 h-4" />
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="surface-card p-4 mt-6">
                <div className="flex items-center justify-between">
                    <span className="text-text-muted">المجموع</span>
                    <span className="text-2xl font-black text-text-main" data-testid="cart-total">
                        {total.toFixed(2)} ر.س
                    </span>
                </div>
                <Link
                    to="/checkout"
                    data-testid="cart-checkout"
                    className="btn-brand block text-center mt-4"
                >
                    <i className="fa-solid fa-arrow-left ms-2" /> متابعة الطلب
                </Link>
            </div>
        </div>
    );
}
